import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { SecondaryButtonLink } from "../../../../components/Buttons";
import { PermissionResource, Resources } from "../../../Permissions";

const mapStateToProps = (state) => ({
  employeeTasks: state.task.employeeTasks,
  failedEmailAddresses: state.task.failedEmailAddresses,
  failedEmailTasks: state.task.failedEmailTasks,
  employeeCompanyChangeTasks: state.task.employeeCompanyChangeTasks,
  // employeeDeactivationTasks: state.task.employeeDeactivationTasks,
});

const renderItem = (label, value) => {
  const labelClassName = value > 0 ? "w3-text-green" : "";
  return (
    <li className="no-pad-tb">
      <span className={`w3-right ${labelClassName}`}>{value || "Keine"}</span>
      <span>{label}</span>
    </li>
  );
};

const TaskDashboard = ({
  className = "",
  holderClassName = null,
  showTotal = false,
  employeeTasks,
  failedEmailAddresses,
  employeeCompanyChangeTasks,
  // employeeDeactivationTasks,
}) => {
  // console.log("UserTaskDashboard.render()", props);
  const failedCompanyEmailTasks = failedEmailAddresses.filter(
    (item) => item.origin === `companyprofile`,
  );
  const failedUserEmailTasks = failedEmailAddresses.filter(
    (item) => item.origin === `userprofile`,
  );

  const total =
    employeeTasks.length +
    failedEmailAddresses.length +
    employeeCompanyChangeTasks.length; /*  + employeeDeactivationTasks.length */
  const totalLabelClassName = total > 0 ? "w3-text-green" : "";

  const content = (
    <SecondaryButtonLink
      id="userTasks"
      className={className}
      to="/aufgaben/benutzer"
      style={{ minHeight: "384px" }}
    >
      <h3 className="no-margin alg-center pad-big-top ">Benutzerverwaltung</h3>
      {showTotal && (
        <div
          className={`pad-top w3-xlarge ${totalLabelClassName} alg-center pad-big-btm w3-border-bottom margin-big-btm`}
          style={{ marginLeft: "-14px", marginRight: "-14px" }}
        >
          {total > 0 ? total : "Keine"}
        </div>
      )}
      <ul className="w3-ul pad-big-btm">
        <PermissionResource resource={Resources.Tasks.UserManagement.Contact}>
          {renderItem("Änderung Kontaktdaten", employeeTasks.length)}
        </PermissionResource>
        <PermissionResource
          resource={Resources.Tasks.UserManagement.CompanyEmails}
        >
          {renderItem(
            "Unversandte E-Mails: Firmen",
            failedCompanyEmailTasks.length,
          )}
        </PermissionResource>
        <PermissionResource
          resource={Resources.Tasks.UserManagement.EmployeeEmails}
        >
          {renderItem(
            "Unversandte E-Mails: Benutzer",
            failedUserEmailTasks.length,
          )}
        </PermissionResource>
        <PermissionResource
          resource={Resources.Tasks.UserManagement.EmployeeCompany}
        >
          {renderItem(
            "Änderung Subunternehmen",
            employeeCompanyChangeTasks.length,
          )}
        </PermissionResource>
        {/* <PermissionResource
          resource={Resources.Tasks.UserManagement.EmployeeDeactivation}
        >
          {renderItem("Mitarbeiter Deaktivieren", employeeDeactivationTasks.length)}
        </PermissionResource> */}
      </ul>
    </SecondaryButtonLink>
  );

  return holderClassName ? <div className={holderClassName}>{content}</div> : content;
};

TaskDashboard.propTypes = {
  className: PropTypes.string,
  holderClassName: PropTypes.string,
  showTotal: PropTypes.bool,
  employeeTasks: PropTypes.array,
  failedEmailAddresses: PropTypes.array,
  employeeCompanyChangeTasks: PropTypes.array,
  // employeeDeactivationTasks: PropTypes.array,
};

export default connect(mapStateToProps)(TaskDashboard);
